import React from 'react';
import PropTypes from 'prop-types';

function Hospitality({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M14.5 15c1.326-.722 1.77-1.827 2.142-3.094 1.101 0 1.358-1.893 1.358-2.194 0-.3.037-.78-1.064-.81V8M9.5 15c-1.326-.722-1.77-1.827-2.142-3.094C6.257 11.906 6 10.013 6 9.712c0-.3-.037-.78 1.064-.81V8M9.333 15v1.057c0 .66.334 1.65-3.333 2.31C2.333 19.029 2 22 2 22h20s0-2.873-4-3.632c-4-.76-3.333-1.651-3.333-2.311V15M7 5.763c2.143-.248 7.857-.32 10 0M7 8c2.143-.426 7.857-.39 10 0V4.13C17 2.71 15.571 2 12 2c-3.571 0-5 .71-5 2.13V8z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M8 17.833A4.932 4.932 0 0012 20a4.933 4.933 0 004-2.167"
      />
    </svg>
  );
}

Hospitality.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Hospitality;
